import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { TitleImgSizeEnum } from "services/custom-section";
import { withVar } from "themes/helpers";

export const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 8px;
  align-items: center;
  width: 100%;
`;

export const StyledTitle = styled.div<{ imgSize: TitleImgSizeEnum; description: string; value: string }>`
  line-height: 20px;
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.description && "min-height: 38px"
  };
  max-height: 200px;
`;

export const Description = styled.div`
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  word-break: break-all;
  word-break: break-word;
  line-height: 15px;
`;

export const Value = styled.div`
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  font-weight: 400;
  padding-left: 10px;
  text-align: right;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;

export const ImageWrapper = css`
  object-fit: cover;
`;

export const TextContainer = styled.div<{ imgDimensions: number; hasImage: boolean }>`
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => `width: calc(100% - ${props.imgDimensions}px)`
  };
  box-sizing: border-box;
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.hasImage && "padding-left: 10px"
  };

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
